import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '../../../shared/services/globals.service';
import { DQOIReferenceData } from '../../models/DQOIReferenceData';

import { SystemService } from '../../services/system.service';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { CommonFunctions } from '../../static/common-functions';
import { PersonNotification } from '../../models/PersonNotification';
import { PersonNotificationParam } from '../../models/PersonNotificationParam';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Message } from '../../models/message';
import { MessageType } from '../../enums/MessageType';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'person-notifications',
    templateUrl: './person-notifications.component.html',
    styleUrls: ['./person-notifications.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PersonNotificationsComponent  {

    constructor( private svc_data: SystemService)
    {
    }
    notifications: any[];
    originalNotifications: any[];
    personNotifications: PersonNotification[];
    _primaryId: any;
    @Input() readOnly: boolean = false;
    @Input() referenceData: DQOIReferenceData;
    @Input() appCode: string;
    @Input() set primaryId(value: any) {
        if (CommonFunctions.hasGuidValue(value)) {
            this._primaryId = value;
            this.getData();
        }
        else {
            this._primaryId = null;
            this.clear();
        }
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    get primaryId(): any {
        return this._primaryId;
    }
    @Output() parentMessageOut: EventEmitter<Message> = new EventEmitter<Message>();

    sendParentMessage(type: MessageType, subject: string = null, message: string = null, values: any = null, value: any = null) {
        let msg: Message = new Message();
        msg.messageType = type;
        msg.messageSubject = subject;
        msg.message = message;
        msg.values = values;
        msg.value = value;
        this.parentMessageOut.emit(msg);
    }

    getData() {
        this.svc_data.getPersonNotifications(this.appCode, this.primaryId).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let arr = [];
                let arrBusObjs = [];
                if (CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let busObj: PersonNotification = new PersonNotification(info.primaryReturn[i]);
                        arr.push(busObj.personId);
                        arrBusObjs.push(busObj);
                    }
                }
                this.notifications = arr;
                this.personNotifications = arrBusObjs;
                this.originalNotifications = _.cloneDeep(this.notifications);
                console.log("persNot->getData->agd: ", arr, arrBusObjs, this.notifications, this.personNotifications);
            }
        });
    }
    valueChanged(e: any) {
        this.sendParentMessage(MessageType.refresh, null, null, null, null);
    }
    clear() {
        this.notifications = [];
        this.originalNotifications = [];
        this.personNotifications = [];
    }
    //        this.gridData = _.remove(this.gridData, function (n) {
    //            return n.CID() !== data.CID();
    //        });
    getObjectsToSave() : PersonNotificationParam {
        let param: PersonNotificationParam = new PersonNotificationParam();
        param.appCode = this.appCode;
        param.primaryId = this.primaryId;
        param.selected = _.cloneDeep(this.notifications);
//        let currNot = _.cloneDeep(this.notifications);
//        let origNot = _.cloneDeep(this.originalNotifications);
//
//        for (let i = 0; i < origNot.length; i++) {
//            let toFind = origNot[i];
//            let index = currNot.find(s => s == toFind);
//
//            if (!index) {
//                //Delete if not found
//                param.toDelete.push(toFind);
//            }
//            else {
//                currNot = _.remove(currNot, function (n) {
//                    return n !== currNot[i];
//                });
//            }
//        }
//        //remaining currNot - Add
//        for (let i = 0; i < currNot.length; i++) {
//
//            param.toAdd.push(currNot[i]);
//        }
          console.log("pn->getobj: ", param);
        return param;
    }
    setup(data: any, code: string = null) {
        this.getData();
    }
    save() {
        let param: PersonNotificationParam = this.getObjectsToSave();
        this.svc_data.savePersonNotifications(param).subscribe((info: BaseMessageInfo) => {
            console.log("persNot->save: ", info);
        });
    }
}
